import axios from 'src/api/Api';
import {
    SEND_INVOICE_SUCCESS,
    SEND_INVOICE_FAILURE,
    RESET_INVOICE,
} from 'src/pages/orders/redux/actions';
import { put, delay } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* sendInvoiceSaga(action) {
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/usage/invoice`;
    try {
        const result = yield axios
            .post(url, action.payload)
            .then((response) => response.data);
        yield put({ type: SEND_INVOICE_SUCCESS, data: result });
        yield delay(1500);
        yield put({ type: RESET_INVOICE });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: SEND_INVOICE_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
